import { Component, output } from '@angular/core';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'eiq-side-panel',
  templateUrl: 'side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  close = output();

  faClose = faClose;
}
